module.exports = __webpack_public_path__ + "img/ic_ac.a5d2d8d3.svg";